import * as Yup from 'yup';

const validationSchema = (t) => {
  return Yup.object().shape({
    raqRotationPlan: Yup.object().shape({
      name: Yup.string().trim().required('الاسم مطلوب'),
      name2: Yup.string().trim().required('الاسم الثاني مطلوب'),
      startDate: Yup.date().required('تاريخ البدء مطلوب'),
      endDate: Yup.date().required('تاريخ الانتهاء مطلوب'),
      description: Yup.string(),
      // allowIn: Yup.string().requir ed('الإذن مطلوب'),
      // allowOut: Yup.string().required('الإذن مطلوب'),
      // count_Fingerprint: Yup.number().required('عدد البصمات مطلوب').min(1, 'يجب أن يكون أكبر من 0'),
    }),

    // sat: Yup.object().shape({
    //   countFingerprint: Yup.number().required('عدد البصمات مطلوب').min(1, 'يجب أن يكون أكبر من 0'),

    //   // allowIn: Yup.string().required('الإذن مطلوب'),
    //   allowOut: Yup.string().required('الإذن مطلوب'),

    //   allowIn: Yup.string()
    //   .required('الإذن مطلوب')
    //   .matches(
    //     /^(?:[01]?[0-9]|2[0-3]):([0-5]?[0-9])$/,
    //     'يجب أن يكون الوقت بصيغة صحيحة (مثال: 23:59)'
    //   )
    //   .test(
    //     'valid-minutes',
    //     'يجب أن تكون الدقائق بين 00 و 59',
    //     (value) => {
    //       if (value) {
    //         const [hours, minutes] = value.split(':').map(Number);
    //         // التأكد من أن الدقائق بين 0 و 59
    //         return minutes >= 0 && minutes <= 59;
    //       }
    //       return true;
    //     }
    //   ),

    //   startIn: Yup.string()
    //     .required('وقت البدء مطلوب')
    //     .when('isExtraDay', {
    //       is: true, // إذا كان isExtraDay = true
    //       then: () =>
    //         Yup.string()
    //           .required('وقت البدء مطلوب')
    //           .test(
    //             'is-before-endOut',
    //             'وقت البدء يجب أن يكون أصغر من وقت الانتهاء',
    //             function (value) {
    //               const endOut = this.resolve(Yup.ref('endOut')); // استخدم Yup.ref للوصول إلى endOut
    //               return value && endOut && value < endOut;
    //             }
    //           ),
    //       otherwise: () => Yup.string().required('وقت البدء مطلوب'),
    //     }),

    //   // startIn: Yup.string().required('وقت البدء مطلوب'),
    //   endOut: Yup.string().required('وقت الانتهاء مطلوب'),
    //   endOut: Yup.string().required('وقت الانتهاء مطلوب'),
    //   endOut: Yup.string().required('وقت الانتهاء مطلوب'),

    //   startIn2: Yup.string().required('وقت البدء مطلوب'),
    //   endOut2: Yup.string().required('وقت الانتهاء مطلوب'),

    //   fingerprintTime1: Yup.string(),
    //   fingerprintTime2: Yup.string(),

    //   fingerprintTime3: Yup.string(),
    //   fingerprintTime4: Yup.string(),
    // }),
  });
};

export default validationSchema;
